import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Unit } from '../../settings-module/models/unit';
import { JobListingItem } from '../../jobs-module/models/listing.model';

@Component({
  selector: 'mj-job-footer',
  templateUrl: './job-footer.component.html',
  styleUrls: ['./job-footer.component.scss'],
})
export class JobFooterComponent {
  @Input() listingItem: JobListingItem;
  @Input() unit: Unit;

  isColorPickerOn;
}
